'use client'
import createOptimisticStateProvider from '@/components/context-factories/create-optimistic-state-provider'
import withSuspendedContext from '@/components/context-factories/with-suspended-context'
import { PropsWithChildren } from 'react'

type AvatarAction = {
  type: 'UPDATE'
  payload: string
}

type AvatarState = string | undefined

const reducer = (state: AvatarState, action: AvatarAction) => {
  switch (action.type) {
    case 'UPDATE':
      return action.payload
    default:
      return state
  }
}

type AvatarProviderProps = PropsWithChildren<{
  value?: AvatarState
}>

const [Provider, useProvider] = createOptimisticStateProvider(reducer)

const [AvatarProvider, useAvatarProvider, withAvatarSuspense] =
  withSuspendedContext(
    ({ value, children }: AvatarProviderProps) => (
      <Provider initialState={value}>{children}</Provider>
    ),
    useProvider,
  )

export { AvatarProvider, useAvatarProvider, withAvatarSuspense }
